import React from 'react'
import styled from "styled-components"
import pic from "./Images/1.jpg"

const About2 = () => {
  return (
    <Container>
      <H1>OTHER SKILLS</H1>
      <Wrapper>
        <Right>
            <ul>
                <li>Team Work</li>
                <li>Communication</li>
                <li>Leadership</li>
                <li>Accountability</li>
                <li>Design thinking <br/> 
                 <div></div>
                </li>
                <li>Effective use of Github</li>
            </ul>
        </Right>
        <Left></Left>
      </Wrapper>
    </Container>
  )
};

export default About2;


const Container = styled.div`
width: 100%;
height: 85vh;
background-color: #2b2c2c;
;
display: flex;
flex-direction: column;
align-items: center;
padding-top: 100px;

@media Screen and (max-width: 768px){
  height: max-content;
  padding: 50px 0;
}
`;
const Wrapper = styled.div`
width: 90%;
height: 80%;
display: flex;
justify-content: space-between;
align-items: center;

@media Screen and (max-width: 768px){
  flex-direction: column;
  justify-content: center;
  height:90%;
}
`;

const H1 = styled.h1`
font-size: 35px;
/* color:#2b2c2c; */
color:#fff;
/* text-decoration:underline double whitesmoke 1px; */
`;

const Left = styled.div`
width: 45%;
height: 100%;
background-image: url(${pic});
background-size: cover;
background-repeat: no-repeat;
border-radius: 10px;
@media Screen and (max-width: 768px){
  width: 90%;
  height: 80vh;
}
@media Screen and (max-width: 425px){
  width: 90%;
  height: 70vh;
  background-position: center;
}
`;
const Right = styled.div`
width: 45%;
height: 100%;
display: flex;
justify-content: center;
align-items: center;
color: white;
font-size: 30px;
background: linear-gradient( 150deg ,whitesmoke 30%, #82390D 54.05%, gold 65%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
/* background-color: purple; */

@media Screen and (max-width: 768px){
  width: 90%;
}
@media Screen and (max-width: 425px){
  width: 90%;
  font-size: 20px;
}
`;